import { AnswerOption } from '@n2-common/serverGeneratedTypings/answerOption';
import { Question } from '@n2-common/serverGeneratedTypings/question';
import { RiskScoreViewModel } from '@n2-common/serverGeneratedTypings/riskScoreViewModel';
import { CddAnswer } from '../../serverGeneratedTypings/cddAnswer';
import { UpdateApplicationCddInputModel } from '../../serverGeneratedTypings/updateApplicationCddInputModel';
import { ServiceMock } from './mock';
import { throwIfNotSuccess } from '../errors';
import { default as fetch } from '@n2-common/lib/fetchProxy';

export type CddServiceInterface = Omit<typeof CddService, 'prototype'>;

class CddService {
    static async fetchCountries() {
        const requestUrl = `/api/n2/duediligence/Countries`;
        const response = await fetch(requestUrl);
        return (await response.json()) as AnswerOption[];
    }
    /**
     * Fetch CDD questions
     *
     * @returns array List of years
     * @param signal Optional AbortSignal, to enable request abortion.
     */
    static async fetchQuestions(productParameters: string, signal?: AbortSignal) {
        const requestUrl = `/api/n2/duediligence/CDD/Questions?${productParameters}`;
        const response = await fetch(requestUrl, { signal });
        await throwIfNotSuccess(response, 'CddService.FetchQuestions');
        return (await response.json()) as Question[];
    }

    static async postToKompisApi(applicationId: string, customerGuid: string, payload: CddAnswer[], includesEnhanced: boolean) {
        const requestUrl = `/api/n2/duediligence/CDD/${applicationId}/${customerGuid}?includesEnhanced=${includesEnhanced}`;
        const model: UpdateApplicationCddInputModel = {
            CddQuestionsWithAnswers: payload,
        };
        const response = await fetch(requestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'error',
            body: JSON.stringify(model),
        });

        await throwIfNotSuccess(response, 'CddService.PostToKompisApi');

        return (await response.json()) as RiskScoreViewModel;
    }
}

export type DueDiligenceType = 'CustomerDueDiligence' | 'OngoingDueDiligence';

const runtimeService = process.env.NODE_ENV == 'production' ? CddService : ServiceMock;

export default runtimeService;
